import { render } from "./ShowDisclaimer.vue?vue&type=template&id=cab9b316"
import script from "./ShowDisclaimer.vue?vue&type=script&lang=js"
export * from "./ShowDisclaimer.vue?vue&type=script&lang=js"

import exportComponent from "../../../vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/leadforms/ShowDisclaimer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cab9b316"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cab9b316', __exports__)) {
    api.reload('cab9b316', __exports__)
  }
  
  module.hot.accept("./ShowDisclaimer.vue?vue&type=template&id=cab9b316", () => {
    api.rerender('cab9b316', render)
  })

}


export default __exports__